import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PhotosSVG = function PhotosSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28,5H8A2.0059,2.0059,0,0,0,6,7v3H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H23a2.0059,2.0059,0,0,0,2-2V24h3a2.0059,2.0059,0,0,0,2-2V7A2.0059,2.0059,0,0,0,28,5ZM13,9a2,2,0,1,1-2,2A2,2,0,0,1,13,9ZM23,26H4V12H6V22a2.0059,2.0059,0,0,0,2,2H23Zm5-10v6H9.5859l7.7071-7.707a.9994.9994,0,0,1,1.414,0L21,16.5859l3.293-3.2929a.9994.9994,0,0,1,1.414,0L28,15.5859Z"
  }));
};
PhotosSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PhotosSVG);